module.exports = __webpack_public_path__ + "img/KSC08615.8e4f1fff.jpg";